import React from 'react'
import { Box, Typography, Container, Grid, Button } from "@mui/material"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList, Rectangle } from 'recharts';
import { useState, useEffect } from 'react';

const GraphicChart = ({ uygunsuzlukDataTable, uygunsuzlukCount }) => {


    return (


        <ResponsiveContainer>
            <BarChart
                data={uygunsuzlukDataTable.sort((a,b)=>{return b.count-a.count})}
            >
                <XAxis dataKey="title" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" fill="#8884d8">
                    {/* <LabelList dataKey="count" position="top" fill='#000000' fontSize={12} /> */}
                    <LabelList dataKey="count" position="center" fill='#000000' fontSize={12} />
                </Bar>
            </BarChart>
        </ResponsiveContainer>






    )
}

export default GraphicChart